import { navigate } from 'gatsby';
import { navigation } from '../middlewares/navigation-constants';
import { CHOOSE_NUMBER_TAB } from '../constants/choose-sim-type';

export const RRP_MODAL = {
  CHANGE_PERSONAL_DETAILS: 'CHANGE_PERSONAL_DETAILS'
};

export const NUMBER_SELECTION_TAB_ITEMS = [
  { title: 'Get new number', value: CHOOSE_NUMBER_TAB.NEW, ref: 'N' },
  { title: 'Transfer existing number', value: CHOOSE_NUMBER_TAB.PORT_IN, ref: 'P' }
];

export default {
  [RRP_MODAL.CHANGE_PERSONAL_DETAILS]: {
    templateId: 'change-personal-details',
    title: 'Change your details?',
    text: 'You will need to log in and select your delivery option again.',
    okText: 'Proceed',
    onOk: () => {
      navigate(`/${navigation.CUSTOMER_REGISTRATION}`);
    }
  }
};
